class Feedback {
    constructor() {
        this.areaClassName = 'usabilla_scroller_area';
        this.mobileView = 605;
        this.width = 650;
        this.height = 480;
        this.widthOffset = 26;

        this.setup();
    }

    setup() {
        document.addEventListener('DOMNodeInserted', (event) => {
            this.handleDOMNodeInserted(event);
        });

        this.isMobile().addListener((event) => {
            this.handleMediaQueryChange(event)
        });
    }

    handleDOMNodeInserted(event) {
        if (event.target.className == this.areaClassName) {
            this.rendering(event.target);
        }
    }



    handleMediaQueryChange(event) {
        const element = document.querySelector(`.${this.areaClassName}`);
        if (element) {
            this.composeLayout(element);
        }
    }

    isMobile() {
        return window.matchMedia(`(max-width: ${this.mobileView}px)`);
    }

    generateStyles() {
        return {
            desktopStyles: `position: fixed; 
                            z-index: 100000;
                            overflow: visible;
                            left: 50% ;
                            top: 50% ;
                            margin-left: calc(-${this.width}px / 2); 
                            margin-top: calc(-${this.height}px / 2); 
                            width: ${this.width}px; 
                            height: ${this.height}px;`,

            mobileStyles: `position: fixed; 
                           z-index: 100000;
                           overflow: visible;
                           left: 0;
                           top: 0;
                           margin: 0;
                           width: 100%;
                           height: ${this.height}px;`,
        }
    }

    rendering(element) {
        if (element) {
            setTimeout(() => {
                const iframe = element.querySelector('iframe');
                if (iframe) {
                    iframe.style.opacity = 0;

                    var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                    var isSafariMac = /^((?!chrome|android|firefox|opera|edge|samsung).)*safari/i.test(navigator.userAgent);

                    if (isIOS || isSafariMac) {
                        setTimeout(() => {
                            const contentDocument = iframe.contentDocument;

                            if (contentDocument) {
                                const body = contentDocument.body;

                                if (body) {
                                    this.width = body.offsetWidth + this.widthOffset;
                                    this.height = body.offsetHeight;
                                }
                            }

                            this.composeLayout(element);
                            iframe.style.opacity = 1;
                        }, 500);
                    } else {
                        iframe.addEventListener('load', () => {
                            const contentDocument = iframe.contentDocument;

                            if (contentDocument) {
                                const body = contentDocument.body;

                                if (body) {
                                    this.width = body.offsetWidth + this.widthOffset;
                                    this.height = body.offsetHeight;
                                }
                            }

                            this.composeLayout(element);
                            iframe.style.opacity = 1;
                        });
                    }
                } else {
                    // fallback if iframe still not exist
                    this.composeLayout(element);
                }
            });
        }
    }

    composeLayout(element) {
        const newStyles = this.generateStyles();

        if (this.isMobile().matches) {
            // mobile
            element.setAttribute('style', newStyles.mobileStyles);

            this.resetCognigyButtons();
        } else {
            // desktop
            element.setAttribute('style', newStyles.desktopStyles);
        }
    }

    resetCognigyButtons() {
        const cognigyButtons = document.querySelector('#showContact');
        if (cognigyButtons.classList.contains('widgets-shown')) {
            cognigyButtons.click()
        }
    }
};

export const FeedbackHelper = () => new Feedback();
